// extracted by extract-css-chunks-webpack-plugin
module.exports = {"aligned":"_1fydoL","grid":"_2dyHo5","centered-section-spacing":"_1fQ6aq","grid-odd":"_2su5jW","box":"drWHGK","header":"_2BvL0s","container":"_3FeonX"};